export class ErrorActions {
  static NULL = '';
  static FIX = 'FIX';
  static IGNORE = 'IGNORE';
}
